import React from 'react';
import { injectIntl } from 'react-intl';
import { get } from 'lodash';

function MoreInfoTextCell(props) {
  const { cell } = props;

  const { original } = cell?.row;

  const { field } = cell.column;

  const data = get(original, field.path);
  return (
    <p className="ellipsis" title={data}>
      {data}
    </p>
  );
}

export default injectIntl(MoreInfoTextCell);
